import React, { useState } from 'react';
import { Button } from '@betareader/design-system';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getFreshIdToken } from '../../utils/authUtil';
import { submitComment, addNewInlineCommentPlaceholder } from '../../modules/comment';

const reactions = [
  ['LIKE', 'Like', '👍'],
  ['LOVE', 'Love', '❤️'],
  ['LAUGH', 'Laugh', '😂'],
  ['SURPRISE', 'Surprise', '😮'],
  ['SAD', 'Sad', '😥'],
  ['ANGRY', 'Angry', '😡']
];

const ReactionsComponent = ({ getEditorState, children }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const userProfile = useSelector(state => state.user.userProfile);
  const currentBook = useSelector(state => state.book.currentBook);
  const currentSpineIndex = useSelector(state => state.readerApp.currentSpineIndex);
  const [submitting, setSubmitting] = useState(null);

  const preserveEditorSelection = event => event.preventDefault();

  const addComment = event => {
    event.preventDefault();
    event.stopPropagation();
    const selection = getEditorState().getSelection();
    dispatch(addNewInlineCommentPlaceholder(
      event.clientX, event.clientY, selection, userProfile
    ));
  };

  const submitReaction = async (event, reaction) => {
    event.preventDefault();
    event.stopPropagation();
    if (submitting) return;
    const currentChapter = currentBook?.parts?.[currentSpineIndex];
    if (!currentChapter) return;

    const selection = getEditorState().getSelection();
    setSubmitting(reaction);
    try {
      const idToken = await getFreshIdToken();
      dispatch(submitComment(
        idToken,
        currentBook._id,
        currentChapter._id,
        undefined,
        {
          reaction,
          kind: 'inline',
          inlineInfo: {
            startKey: selection.getStartKey(),
            startOffset: selection.getStartOffset(),
            endKey: selection.getEndKey(),
            endOffset: selection.getEndOffset()
          }
        },
        () => {
          setSubmitting(null);
          if (document.activeElement !== document.body) {
            document.activeElement.blur();
          }
        }
      ));
    } catch (error) {
      setSubmitting(null);
      console.error(error);
    }
  };

  return (
    <>
      {children}
      <Button variant='secondary' size='small' aria-label={t('EnterComment')}
        onMouseDown={preserveEditorSelection} onClick={addComment}>
        <span aria-hidden='true'>💬</span>
      </Button>
      {reactions.map(([reaction, label, symbol]) => (
        <Button key={reaction} variant='secondary' size='small'
          aria-label={t(label)} onMouseDown={preserveEditorSelection}
          onClick={event => submitReaction(event, reaction)}
          disabled={Boolean(submitting)} aria-busy={submitting === reaction}>
          <span aria-hidden='true'>{symbol}</span>
        </Button>
      ))}
    </>
  );
};

export default ReactionsComponent;
